module.exports = __webpack_public_path__ + "img/en.1765d53d.png";